<template>
<div class="order bg-gray-100 dark:bg-gray-700 rounded p-4 mt-3">
    <div class=" text-gray-700 dark:text-gray-200 mt-3 mb-4 col-span-3 text-center">Top 3 Operators</div>
    <draggable
        v-model="operators"
        handle=".handle"
        ghost-class="opacity-50"
        class="grid grid-cols-3 gap-3"
        @choose="froalaStore.disableFroala = true"
        @unchoose="froalaStore.disableFroala = false"
    >
        <div v-for="(operator, key) in operators" :key="`operator-${key}`" class="p-2 rounded bg-white dark:bg-gray-800">

            <div class="handle float-left" v-tooltip="{ content: 'Drag to reorder operators', container: false, placement: 'top', html: false, }">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 rotate-90" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                </svg>
            </div>

            <div class="float-right cursor-pointer" @click="resetOperator(operator)" v-tooltip="{ content: 'Reset Operator', container: false, placement: 'top', html: false, }">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="ml-2 w-5 h-5 inline-block">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                </svg>
            </div>

            <div class="text-center mb-4">Operator {{ operator.order +1 }}</div>

            <p class="text-gray-700 dark:text-gray-200">* Casino</p>
            <reference
                create-text="Create new casino and link casino to this page"
                link-text="Link an existing casino"
                :language="language"
                v-model="operator.casino"
                model-data="Casino"
                :should-open-new-window="true"
                :creatable="false"
                :query="{
                    'casinoReview.status_id': 1
                }"
                :order="{
                    'name': 'asc'
                }"
                :error="errorBag?.[`${operator.order}.casino.id`]?.[0] ?? null"
            />

            <p class="text-gray-700 dark:text-gray-200 mt-3">* Bonus</p>
            <reference
                create-text="Create new bonus and link bonus to this page"
                link-text="Link an existing bonus"
                :language="language"
                model-data="Bonus"
                v-model="operator.bonus"
                :should-open-new-window="true"
                :creatable="false"
                :query="{
                    'casino_id': operator?.casino?.id ?? null,
                }"
                :order="{
                    'name': 'asc'
                }"
                :error="errorBag?.[`${operator.order}.bonus.id`]?.[0] ?? null"
            />

            <Select
                label="Label Text Type"
                name="label_text_type"
                class="mt-3"
                v-model="operator.label_text_type"
                :options="[
                    { value: '', name: 'No label'},
                    { value: 'free', name: 'Free Text'},
                    { value: 'predefined', name: 'Predefined'},
                ]"
                @input="labelTextTypeChanged(operator)"
            />

            <input-text
                name="label_text"
                label="* Label Free Text"
                class="mt-3"
                v-model="operator.label_text"
                v-if="(operator.label_text_type == 'free')"
               :maxlength="255"
                :error="errorBag?.[`${operator.order}.label_text`]?.[0] ?? null"
            />

            <Select
                label="* Label Predefined Text"
                name="label_key"
                class="mt-3"
                v-if="(operator.label_text_type == 'predefined')"
                v-model="operator.label_key"
                :options="[
                    { value: '', name: ''},
                    { value: 'ribbon.communityTopChoice', name: 'Community Top Choice' },
                    { value: 'ribbon.editorsTopChoice', name: 'Editors Top Choice'},
                    { value: 'ribbon.playersChoiceOfTheMonth', name: 'Players Choice of the Month' },
                    { value: 'ribbon.mostAwardedCasinoOfYear', name: 'Most Awarded Casino of year'},
                    { value: 'ribbon.newestCasinoReview', name: 'Newest Casino Review' },
                    { value: 'ribbon.trustCategoryWinner', name: 'Trust Category Winner' },
                    { value: 'ribbon.mostVisitedCasino', name: 'Most visited Casino'},
                    { value: 'ribbon.latestCasinoBonus', name: 'Latest Casino Bonus' },
                    { value: 'ribbon.highestBonusPercentage', name: 'Highest Bonus Percentage'},
                    { value: 'ribbon.mostPopularWelcomeBonus', name: 'Most Popular Welcome Bonus' },
                    { value: 'ribbon.mostUsedFreeSpinBonus', name: 'Most used Free Spin Bonus' },
                    { value: 'ribbon.mostGenerousNoDepositBonus', name: 'Most generous No Deposit Bonus' },
                    { value: 'ribbon.playersFavoriteNoDepositBonus', name: 'Players’ Favorite No Deposit Bonus'},
                    { value: 'ribbon.highestCashbackOffer', name: 'Highest Cashback Offer' },
                    { value: 'ribbon.perfectForHighRollers', name: 'Perfect for High Rollers'},
                    { value: 'ribbon.exclusiveOffer', name: 'Exclusive Offer' }
                ]"
                :error="errorBag?.[`${operator.order}.label_key`]?.[0] ?? null"
            />

            <Select
                label="* Label Color"
                name="label_color"
                class="mt-3"
                v-if="(operator.label_text_type)"
                v-model="operator.label_color"
                :options="[
                    { value: '', name: ''},
                    { value: 'cta',     name: 'Base CTA' },
                    { value: 'purple',  name: 'Purple '},
                    { value: 'green',   name: 'Green' },
                    { value: 'cyan',    name: 'Cyan'},
                    { value: 'amber',   name: 'Amber' },
                    { value: 'blue',    name: 'Blue' }
                ]"
                :error="errorBag?.[`${operator.order}.label_color`]?.[0] ?? null"
            />

        </div>
    </draggable>
</div>
</template>

<script>
import draggable from "vuedraggable";
import InputText from "../form/InputText.vue";
import siteLanguage from "../../config/siteLanguage";
import {useFroalaStore} from "../../stores/froala";

export default {

    components: {InputText, draggable },
    name: "Top3Operators",
    props: {
        value: {
            type: [Object, Array],
            required: false,
            default: () => {
                return [];
            }
        },
        errorBag: {
            type: [Object, Array],
            required: false,
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
    },
    data() {
        return {
            operators: this.value,
            froalaStore: useFroalaStore(),
        };
    },
    methods: {
        labelTextTypeChanged(operator) {
            operator.label_text = null;
            operator.label_key = null;
            operator.label_color = null;
        },

        resetOperator(operator) {
            operator.casino = null;
            operator.casino_id = null;
            operator.bonus = null;
            operator.bonus_id = null;
            operator.label_text_type = null;
            operator.label_text = null;
            operator.label_key = null;
            operator.label_color = null;
        }
    },
    watch: {
        operators: {
            immediate: true,
            handler: function (newValue) {
               const NUMBER_OF_OPERATORS = 3;
                if (newValue.length < NUMBER_OF_OPERATORS) {
                    for(let i = newValue.length; i < NUMBER_OF_OPERATORS; i++) {
                        this.$set(newValue, i, {
                            'order': i,
                            'bonus': null,
                            'casino': null,
                        });
                    }
                }

                let order = 0;
                for(let operator in newValue) {
                    newValue[operator]['order'] = order++;
                    newValue[operator]['casino_id'] = newValue?.[operator]?.['casino']?.['id'] ?? null;
                    if (newValue?.[operator]?.['casino']?.['id']) {
                        newValue[operator]['bonus_id'] = newValue?.[operator]?.['bonus']?.['id'] ?? null;
                    } else {
                        newValue[operator]['bonus_id'] = null;
                        newValue[operator]['bonus'] = null;
                    }
                }

                this.$emit("input", newValue);
            },
            deep: true,
        }
    }
};
</script>
